import { Icon_errorWith, debouncer } from "./View/Prelude.js";
import { LocalStorage_loadApp, LocalStorage_subscribe, LocalStorage_savePresets, LocalStorage_saveState } from "./Data.js";
import { AppMessage, state as state_1, presets as presets_3 } from "./Update.js";
import { Util_console, App } from "./Types.js";
import { createElement } from "react";
import { createObj } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { section as section_1, LoadSave_nuclearReset } from "./View/Settings.js";
import { singleton, ofArray } from "./fable_modules/fable-library-js.4.29.0/List.js";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { printf, toText } from "./fable_modules/fable-library-js.4.29.0/String.js";
import { some } from "./fable_modules/fable-library-js.4.29.0/Option.js";
import { ErrorBoundary as ErrorBoundary_1 } from "react-error-boundary";
import { section } from "./View/Visualization.js";
import { ProgramModule_mkSimple, ProgramModule_withErrorHandler, ProgramModule_withSubscription, ProgramModule_run } from "./fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Program_withReactSynchronous } from "./fable_modules/Fable.Elmish.React.5.0.0/react.fs.js";

export const saveState = debouncer(100, (tupledArg) => {
    LocalStorage_saveState(tupledArg[0], tupledArg[1]);
});

export const savePresets = debouncer(100, (presets) => {
    LocalStorage_savePresets(presets);
});

export function update(msg, app) {
    switch (msg.tag) {
        case 1: {
            const presets_1 = presets_3(msg.fields[0], app.Presets);
            savePresets(presets_1);
            return new App(app.Data, presets_1, app.State);
        }
        case 2:
            return new App(app.Data, msg.fields[0], app.State);
        case 3: {
            localStorage.clear();
            window.location.reload();
            return app;
        }
        default: {
            let state;
            const tupledArg = app.State;
            state = state_1(msg.fields[0], app.Data, tupledArg[0], tupledArg[1]);
            saveState(state);
            return new App(app.Data, app.Presets, state);
        }
    }
}

export function viewError(e, dispatch) {
    let elems, children_2, children, str, children_4;
    return createElement("div", createObj(ofArray([["id", "app-error"], (elems = [(children_2 = singleton(Icon_errorWith((children = ofArray([(str = "\r\n          Whoops, something went wrong. Please try reloading the page.\r\n          If this message remains after reloading the page, try doing a\r\n        ", str), LoadSave_nuclearReset(dispatch)]), createElement("span", {
        children: reactApi.Children.toArray(Array.from(children)),
    })))), createElement("span", {
        children: reactApi.Children.toArray(Array.from(children_2)),
    })), (children_4 = ofArray([createElement("summary", {
        children: ["Error Message"],
    }), createElement("div", {
        children: [toText(printf("%A"))(e)],
    })]), createElement("details", {
        children: reactApi.Children.toArray(Array.from(children_4)),
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function view(app, dispatch) {
    try {
        return createElement(ErrorBoundary_1, {
            fallbackRender: (e) => viewError(e.error, dispatch),
            children: [section(app, (arg) => {
                dispatch(new AppMessage(0, [arg]));
            }), section_1(app, dispatch)],
        });
    }
    catch (e_1) {
        Util_console.log(some(e_1));
        return viewError(e_1, dispatch);
    }
}

export function localStorageSub(dispatch) {
    LocalStorage_subscribe((arg) => {
        dispatch(new AppMessage(2, [arg]));
    });
    return {
        Dispose() {
        },
    };
}

ProgramModule_run(Program_withReactSynchronous("app", ProgramModule_withSubscription((_arg) => singleton([singleton("localStorage"), localStorageSub]), ProgramModule_withErrorHandler((tupledArg) => {
    Util_console.error(some(new Error(tupledArg[0], { cause: tupledArg[1] })));
}, ProgramModule_mkSimple(LocalStorage_loadApp, update, view)))));

//# sourceMappingURL=Main.js.map
